import { Editor } from "@tinymce/tinymce-react"
import Delete from "./Delete"
import { useRef, useState } from "react"
import { toast } from "react-toastify"
import AddEquation from "../../../../../components/AddEquation"

export default function QuestionEditor({
  title,
  color,
  children,
  className,
  answerBody,
  deleteOption,
  answerOptions,
  answerOptionID,
  editorDisabled,
  setAnswerOptions,
  index
}) {
  const editorRef = useRef(null)

  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className={`w-full rounded-[14px] bg-white ${className}`}>
      <AddEquation
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        setAnswerBody={setAnswerOptions}
        index={index}
        multi={deleteOption ? true : false}
      />
      <div
        className={`flex justify-between rounded-t-[14px] ${color} px-5 py-2.5 text-white`}
      >
        <p className="mx-auto">{title}</p>
        {deleteOption && (
          <Delete
            answerOptionsId={answerOptionID}
            setAnswerOptions={setAnswerOptions}
            answerOptions={answerOptions}
          />
        )}
      </div>
      {!editorDisabled && (
        <>
          <Editor
            apiKey="axkh0zkhttgh2c30gcxj3oh6njsj9y44pis1y3cu0aiv1rkv"
            onInit={(_evt, editor) => (editorRef.current = editor)}
            value={answerBody}
            init={{
              height: 278,
              // menubar: true,
              menubar: "format",
              statusbar: false,
              plugins: "image  link nonbreaking",
              toolbar:
                "bold italic underline image link nonbreaking add-equation",
              // nonbreaking_force_tab: true,
              content_style:
                "#tiny-react_899652985121678943217552_ifr {padding-right: 8px;}" +
                "body { font-family: 'Poppins', sans-serif; font-size: 18px;" +
                "color: #535B61;line-height: 27px; overflow-Y: auto;   }" +
                "body::-webkit-scrollbar {width: 6px;}" +
                "body::-webkit-scrollbar-thumb {background-color: #cfcfcf; border-radius: 6px 6px 6px 6px;}" +
                "body::-webkit-scrollbar-track {background: #e9e9e9; border-radius: 6px 6px 6px 6px; margin: 10px 10px;}" +
                "span.mce-nbsp-wrap {  text-decoration: underline;}",
              file_picker_types: "image",
              file_picker_callback: function (cb) {
                var input = document.createElement("input")
                input.setAttribute("type", "file")
                input.setAttribute("accept", "image/*")

                input.onchange = function () {
                  var file = this.files[0]

                  if (!file.type.match("image.*")) {
                    toast.info("File must be an image")
                    return
                  }

                  if (file.size > 2 * 1024 * 1024) {
                    toast.info("File size must be less than 2MB")
                    return
                  }

                  var reader = new FileReader()
                  reader.onload = function () {
                    var id = "blobid" + new Date().getTime()
                    var blobCache =
                      window.tinymce.activeEditor.editorUpload.blobCache
                    var base64 = reader.result.split(",")[1]
                    var blobInfo = blobCache.create(id, file, base64)
                    blobCache.add(blobInfo)

                    cb(blobInfo.blobUri(), { title: file.name })
                  }
                  reader.readAsDataURL(file)
                }

                input.click()
              },
              setup: function (editor) {
                editor.ui.registry.addButton("add-equation", {
                  icon: "fx",
                  tooltip: "Add Equation",
                  // text: "fx",
                  onAction: function () {
                    setIsOpen(true)
                  }
                })
              }
            }}
            onEditorChange={newValue => {
              answerOptions &&
                setAnswerOptions(
                  answerOptions.map(answerOption => {
                    if (answerOption.id === answerOptionID) {
                      return {
                        ...answerOption,
                        body: newValue
                      }
                    }
                    return answerOption
                  })
                )
            }}
          />
        </>
      )}
      {children}
    </div>
  )
}
